import React from 'react';

import { cn } from '@shared/utils/lib/ui';

import { TagProps, tagVariants } from './Tag.styles';
import { FlexLayout } from '../Layout/Flex';
import { Body } from '../Typography';

const Tag: React.FC<TagProps> = ({ color, label, size = 'small' }) => (
  <FlexLayout>
    <FlexLayout className={cn(tagVariants({ color, size }))} alignItems='center' justifyContent='center'>
      <Body color='inverse' size={size}>
        {label}
      </Body>
    </FlexLayout>
  </FlexLayout>
);

export { Tag };
